import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=db47bb4e"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=db47bb4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports